/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { formStyles, mixins } from '@blend/consumer-components';
import { TaskInputs } from '../TaskInputs';
import { InputConfig } from '../types';
import { IconHeader } from '@components/IconHeader/IconHeader';

export namespace InputGroup {
  export interface Props {
    index: string;
    display: string;
    imageName: string;
    inputs: InputConfig[];
  }
}

const styles = StyleSheet.create({
  InputGroup: {
    ...mixins.globalBorderStyle,
    ...formStyles.inputPadding(),
  },
  header: {
    display: 'flex',
    alignItems: 'center',
  },
  body: {
    marginTop: 25,
  },
});

export const InputGroup: React.FC<InputGroup.Props> = ({ index, display, imageName, inputs }) => {
  return (
    <section className={css(styles.InputGroup)} data-it="InputGroupSection" data-index={index}>
      <header className={css(styles.header)}>
        <IconHeader title={display} imageName={imageName} />
      </header>
      <div data-it="InputGroupBody" className={css(styles.body)}>
        <TaskInputs inputs={inputs} />
      </div>
    </section>
  );
};
